/**
 * Whether two texts are the same to a formula: case-insensitive, as in
 * spreadsheets ("TC" = "tc" is TRUE) and as a dropdown column matches its
 * options, so a literal typed in another case doesn't silently match nothing.
 */
export function textEquals(a, b) {
    return a.toLowerCase() === b.toLowerCase();
}
//# sourceMappingURL=text-equals.js.map